import type { AnimalSummary } from '../../shared/types/api';

interface AnimalCardProps {
  animal: AnimalSummary;
  unlocking: boolean;
  onSelect: () => void;
  onUnlock: () => void;
}

export function AnimalCard({ animal, unlocking, onSelect, onUnlock }: AnimalCardProps) {
  return (
    <article className={`animal-card ${animal.unlocked ? 'is-unlocked' : 'is-locked'}`}>
      <div className="portrait-wrap">
        <img src={animal.portraitUrl} alt={`${animal.name} the ${animal.speciesName}`} />
        {!animal.unlocked && (
          <span className="lock-badge" aria-label="Locked">
            🔒
          </span>
        )}
      </div>
      <div className="animal-card-body">
        <p className="species-label">{animal.speciesName}</p>
        <h2>{animal.name}</h2>
        <p>{animal.personality}</p>
        <button
          type="button"
          disabled={unlocking}
          onClick={animal.unlocked ? onSelect : onUnlock}
          aria-label={
            animal.unlocked
              ? `Follow ${animal.name}'s trail`
              : unlocking
                ? `Preparing ${animal.name}'s trail`
                : `Unlock ${animal.name}'s trail`
          }
        >
          {animal.unlocked ? (
            <>
              Open trail <span aria-hidden="true">→</span>
            </>
          ) : unlocking ? (
            'Preparing trail…'
          ) : (
            <>
              Unlock trail <span aria-hidden="true">✦</span>
            </>
          )}
        </button>
      </div>
    </article>
  );
}
